import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 50px;
  padding-top: 0px;

  .title {
    text-align: left;
    font-family: Roboto;
    font-weight: Bold;
    font-size: 18px;
    letter-spacing: 0;
    color: #384264;
    opacity: 1;
    padding: 10px;
  }
  .headerTitle {
    text-align: left;
    font-size: 14px;
    letter-spacing: 0;
    color: rgba(43, 39, 39, 1);
    text-transform: none;
    opacity: 1;
    font-family: Roboto;
    padding-bottom: 16px;
    font-weight: Bold;
    background-color: rgba(248, 248, 248, 1);
  }
  .row {
    border-radius: 4px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-size: 13px;
    font-weight: 500;
    color: #2b2727;
  }
  .claims {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .add-button {
    cursor: 'pointer';
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
  .action-row {
    border-radius: 4px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-size: 13px;
    font-weight: 500;
    color: rgba(0, 117, 201, 1);
  }
`;
